import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"
import MenuItem from "./MenuItem"
import { SubMenus } from "./MenuItemLink"
import useUserStore from "stores/user"
import { useAuthenticatedUser } from "auth-provider"
import ConditionalView from "components/ConditionalView"

const MenuItemWithChildren = ({
  item,
  linkClassName,
  subMenuClassNames,
  activeMenuItems,
  toggleMenu,
}: SubMenus) => {
  const { user } = useAuthenticatedUser()
  const [open, setOpen] = useState<boolean>(activeMenuItems!.includes(item.key))
  const isCustomer = useUserStore((state) => state.isCustomer)
  const isExternal = useUserStore((state) => state.isExternal)
  const isCommonCarrier = useUserStore((state) => state.isCommonCarrier)
  const hasPricePermission = useUserStore((state) => state.hasPricePermission)

  useEffect(() => {
    setOpen(activeMenuItems!.includes(item.key))
  }, [activeMenuItems, item])

  const toggleMenuItem = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault()
    const status = !open
    setOpen(status)
    if (toggleMenu) toggleMenu(item, status)
    return false
  }

  return (
    <li className={classNames("side-nav-item", { "menuitem-active": open })}>
      <Link
        to="#"
        onClick={toggleMenuItem}
        data-menu-key={item.key}
        aria-expanded={open}
        className={classNames("has-arrow", "side-sub-nav-link", linkClassName, {
          "menuitem-active": activeMenuItems!.includes(item.key)
            ? "active"
            : "",
        })}
      >
        {item.icon && <i className={item.icon}></i>}
        <span> {item.label} </span>
        {/* <i className="ri-arrow-right-s-line"></i> */}
      </Link>
      <ConditionalView condition={open}>
        <ul className={classNames(subMenuClassNames)}>
          {(item.children || []).map((child, index) => {
            if (child?.hide) return null
            if (isCustomer && !child.showForCustomer) return null
            if (isCommonCarrier && child.hideForCC) return null
            if (isExternal && child.hideForExternal) return null
            if (child.adminOnly && !user?.groups?.includes("Admin")) return null
            if (child.priceOnly && !hasPricePermission) return null

            return (
              <React.Fragment key={index.toString()}>
                {child.children ? (
                  <>
                    {/* parent */}
                    <MenuItemWithChildren
                      item={child}
                      linkClassName={
                        activeMenuItems!.includes(child.key) ? "active" : ""
                      }
                      activeMenuItems={activeMenuItems}
                      subMenuClassNames="side-nav-third-level"
                      toggleMenu={toggleMenu}
                    />
                  </>
                ) : (
                  <>
                    {/* child */}
                    <MenuItem
                      item={child}
                      className={
                        activeMenuItems!.includes(child.key)
                          ? "menuitem-active"
                          : ""
                      }
                      linkClassName={
                        activeMenuItems!.includes(child.key) ? "active" : ""
                      }
                    />
                  </>
                )}
              </React.Fragment>
            )
          })}
        </ul>
      </ConditionalView>
    </li>
  )
}

export default MenuItemWithChildren
